module.exports = __webpack_public_path__ + "img/logo-horizontal-NSeguros.8d7bdb38.png";